import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Build the snapshot we persist for share links / email.
export function buildSnapshot(gov) {
  return {
    answers: gov.answers || {},
    exposure: gov.exposure || {},
    policy: gov.policy || null,
    qa: gov.qa || null,
    roi: gov.roi || null,
    deploy: gov.deploy || {},
    framework: gov.framework || null,
    skjold: gov.skjold || null,
    result: gov.result || null,
  };
}

export function buildSummary(gov) {
  const tools = [];
  if (gov.result) tools.push("Readiness Assessment");
  if (gov.policy) tools.push("Policy Builder");
  if (gov.qa) tools.push("QA Calculator");
  if (gov.roi) tools.push("ROI & Value Calculator");
  if (gov.deploy && Object.keys(gov.deploy).length) tools.push("Deployment Configurator");
  if (gov.framework) tools.push(`Framework: ${gov.framework}`);
  return {
    band: gov.result?.band?.band || null,
    overall: gov.result?.overall ?? null,
    tools,
  };
}

export async function createReport(gov) {
  const res = await axios.post(`${API}/governance/reports`, {
    state: buildSnapshot(gov),
    summary: buildSummary(gov),
  });
  const id = res.data.id;
  return { id, url: `${window.location.origin}/r/${id}` };
}

export async function getReport(token) {
  const res = await axios.get(`${API}/governance/reports/${token}`);
  return res.data;
}

export async function emailReport(reportId, { name, email, consent }) {
  const res = await axios.post(`${API}/governance/reports/email`, {
    report_id: reportId, name, email, consent, base_url: window.location.origin,
  });
  return res.data;
}
